import { supabase } from './supabase'

export const CORAL = '#E8522A'
export const CHARBON = '#1C1C1C'
export const SABLE = '#f5f0eb'

// Met à jour la carte dans le téléphone du client (sans bloquer l'interface)
export function syncWallet(clientId) {
  supabase.functions
    .invoke('generate-wallet-card', { body: { clientId, action: 'sync' } })
    .then(({ data, error }) => {
      if (error || data?.error) console.error('Sync Wallet:', error || data.error)
    })
}

// +1 tampon : met à jour le compteur, enregistre la visite, rafraîchit la carte Wallet.
// Renvoie le nouveau nombre de tampons.
export async function ajouterTampon(client, commerceId) {
  const nouveauxTampons = (client.tampons || 0) + 1
  const { error: errUpdate } = await supabase
    .from('clients')
    .update({ tampons: nouveauxTampons })
    .eq('id', client.id)
  if (errUpdate) throw errUpdate

  const { error: errVisite } = await supabase
    .from('visites')
    .insert({ client_id: client.id, commerce_id: commerceId })
  if (errVisite) throw errVisite

  syncWallet(client.id)
  return nouveauxTampons
}

// Récompense donnée : la carte repart à zéro
export async function donnerRecompense(clientId) {
  const { error } = await supabase
    .from('clients')
    .update({ tampons: 0 })
    .eq('id', clientId)
  if (error) throw error
  syncWallet(clientId)
}

export function Logo({ size = 40 }) {
  return (
    <div style={{ width: size, height: size, background: CORAL, borderRadius: size / 4, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <svg width={size * 0.6} height={size * 0.6} viewBox="0 0 100 100" fill="none">
        <rect x="10" y="14" width="44" height="26" rx="5" fill="#fff" opacity="0.5" transform="rotate(-5 32 27)"/>
        <rect x="14" y="8" width="44" height="26" rx="5" fill="#fff" opacity="0.9" transform="rotate(3 36 21)"/>
        <rect x="8" y="44" width="72" height="48" rx="10" fill="#fff" opacity="0.95"/>
        <circle cx="79" cy="67" r="5.5" fill={CORAL}/><circle cx="79" cy="67" r="2.5" fill="#fff"/>
      </svg>
    </div>
  )
}

export function LiensLegaux({ style }) {
  const lien = { color: '#999', textDecoration: 'none' }
  return (
    <div style={{ fontSize: 11, color: '#999', textAlign: 'center', display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap', ...style }}>
      <a href="/legal/mentions" style={lien}>Mentions légales</a>
      <a href="/legal/confidentialite" style={lien}>Confidentialité</a>
      <a href="/legal/cgv" style={lien}>CGV</a>
    </div>
  )
}
